/**
 * 외부 결재 화면(`/approval/:token`)의 **오류 제목표** — 서버가 내려준 `code` → 화면 제목.
 *
 * 본문 문구는 언제나 서버 `message`를 그대로 쓴다(셸이 제목 아래에 그린다). 여기 없는 코드는
 * `ExternalSignatureShell`이 「오류가 발생했습니다」로 떨어뜨리므로, **서버가 이 페이지의
 * 두 엔드포인트(`GET /approval/:token`·`POST /approval/:token/process`)에서 낼 수 있는 wire
 * 코드는 빠짐없이 여기 있어야 한다.** 정본은 `apps/server/src/reports/external-approval.controller.ts`
 * 이고, 그 대조는 `__tests__/approvalErrorTitles.test.ts`가 컨트롤러 소스를 읽어 기계로 지킨다.
 *
 * 페이지 자신이 만드는 클라이언트 코드(`NETWORK_ERROR`·`PROCESS_ERROR`)는 별도다 —
 * `PROCESS_ERROR`는 「처리 중 오류가 발생했습니다」라는 일반 문구가 곧 제목이 될 말이라
 * 일부러 등재하지 않고 셸 기본 제목으로 떨어뜨린다.
 *
 * ⚠️ 제목에 「만료」·「유효하지 않은」을 함부로 쓰지 않는다 — 링크가 멀쩡한데 사정이 바뀐
 * 경우(담당자 변경·재제출·차례 아님)에 그 말을 쓰면 받은 사람이 있지도 않은 「새 링크」를
 * 요청하게 된다(결정 2026-08-27-unresolved-approval-slot-park-and-resume.md §5).
 */
export const APPROVAL_ERROR_TITLES: Record<string, string> = {
  TOKEN_NOT_FOUND: '링크를 찾을 수 없습니다',
  // ⚠️ 제목에도 "만료"·"유효하지 않은"을 쓰지 않는다 — 링크는 멀쩡했고 담당자가 바뀐 것이다
  // (결정 2026-08-27-unresolved-approval-slot-park-and-resume.md §5). 본문 문구는 서버가
  // 내려주는 message를 그대로 쓴다(셸이 제목 아래에 그린다).
  APPROVER_CHANGED: '결재 담당자가 변경되었습니다',
  // 반려 후 재제출로 삭제된 옛 링크(줄기 stale-approval-link-notice-after-resubmit) — 같은 결로
  // 제목에 "만료"·"유효하지 않은"을 쓰지 않는다. 본문(새 링크 안내)은 서버 message가 맡는다.
  RESUBMITTED: '문서가 다시 제출되었습니다',
  TOKEN_EXPIRED: '링크가 만료되었습니다',
  APPROVAL_SIGNATURE_EXPIRED: '만료된 결재 링크입니다',
  ALREADY_PROCESSED: '이미 처리됨',
  // 앞 단계가 아직 결재하지 않은 채 이 링크로 처리를 시도한 경우(`POST :token/process`).
  // 링크도 담당자도 멀쩡하고 **차례만** 아니므로 여기서도 "만료"라 하지 않는다 — 기다리면
  // 그대로 쓸 수 있는 링크다. 본문(「이전 단계 결재가 완료되지 않았습니다」)은 서버 message.
  APPROVAL_ORDER_VIOLATION: '아직 결재 차례가 아닙니다',
  REPORT_CANCELLED: '결재 취소됨',
  REPORT_DELETED: '보고서 삭제됨',
  NETWORK_ERROR: '연결 오류',
  // 📌 `STALE_ROUND`는 여기 없다 — 서버 **내부 사유** 이름이고 wire로는
  // `APPROVAL_SIGNATURE_EXPIRED`로 접혀 나간다(external-approval.controller.ts `getErrorResponse`).
  // 등재해 두면 영영 안 쓰이는 죽은 항목이라 지웠다(2026-09-19).
};
